<template>
  <a-drawer
    :confirmLoading='confirmLoading'
    :keyboard='false'
    :maskClosable='false'
    :title='title'
    :visible='visible'
    width='100%'
    @close='prev'>
    <a-spin :spinning='confirmLoading'>
      <a-steps :initial='0' :current='current'>
        <a-step description='选择公式数据源' title='选择公式更新字段'></a-step>
        <a-step description='选择公式中涉及的来源数据' title='选择公式数据源'></a-step>
        <a-step description='设置公式数据源取值的周期配置' title='设置周期配置'></a-step>
        <a-step description='预配置特殊类型公式（可跳过）' title='设置子公式'></a-step>
        <a-step description='根据数据源及子公式进行配置' title='设置最终公式'></a-step>
        <a-step description='进行结果映射（可跳过）' title='结果解释'></a-step>
      </a-steps>
      <a-divider />
      <dict-item-texts v-if="model.formItem && model.formItem.dictItemList&&model.formItem.dictItemList.length>0" :dictItemList="model.formItem.dictItemList"></dict-item-texts>
      <a-tabs v-model='current'>
        <a-tab-pane :key='0' tab=''>
          <step1 ref='step1' ></step1>
        </a-tab-pane>
        <a-tab-pane :key='1' tab=''>
          <step2 ref='step2' @is-loading="changeLoad"></step2>
        </a-tab-pane>
        <a-tab-pane :key='2' tab=''>
          <step3 ref='step3' ></step3>
        </a-tab-pane>
        <a-tab-pane :key='3' tab=''>
          <step4 ref='step4' ></step4>
        </a-tab-pane>
        <a-tab-pane :key='4' tab=''>
          <step5 ref='step5' ></step5>
        </a-tab-pane>
        <a-tab-pane :key='5' tab=''>
          <step6 ref='step6' ></step6>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <div class='footer-btn'>
      <a-button style="margin-right: 12px" @click="prev">{{ cancelText }}</a-button>
      <a-button type="primary" :loading="loading" @click="next">{{ okText }}</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postAction } from '@api/manage'
import Step1 from '@views/tempconfig/formula/Step1'
import Step2 from '@views/tempconfig/formula/Step2'
import Step3 from '@views/tempconfig/formula/Step3'
import Step4 from '@views/tempconfig/formula/Step4'
import Step5 from '@views/tempconfig/formula/Step5'
import Step6 from '@views/tempconfig/formula/Step6'
import DictItemTexts from './DictItemTexts'

export default {
  name: 'FormulaModel',
  components: { DictItemTexts, Step6, Step5, Step4, Step3, Step2, Step1 },
  props:{
    // projectId:{
    //   type:String,
    //   default:''
    // }
  },
  data() {
    return {
      title: '新增公式',
      visible: false,
      model: {},
      confirmLoading: false,

      current: -1,
      cancelText: '关闭',
      okText: '下一步',
      loading: false,

    }
  },
  created() {
  },
  methods: {
    changeLoad(value) {
      this.loading = value
    },
    add() {
      //初始化默认值
      this.edit({
        type:'1'
      })
    },
    edit(record) {
      this.cancelText = '关闭'
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(()=>{
        this.next()
      })

    },
    close() {
      this.model = {}
      this.$emit('close')
      this.current = -1
      this.okText= '下一步'
        this.visible = false
    },
    /*保存新增公式,触发请求*/
    handleOk() {
      const that = this

      this.$confirm({
        title: '再次确认',
        content: '确定要保存信息吗?',
        onOk() {
          // 需要处理格式，减少数据参数传输，直接传model有非常多冗余
          const itemList = []
          if(that.model.itemList1){
            that.model.itemList1.forEach(item=>{
              const mappingList = []
              if(item.mappingList){
                item.mappingList.forEach(mapping=>{
                  mappingList.push({
                    dictText : mapping.text,
                    dictValue:mapping.value,
                    mappingValue:mapping.mappingValue || '',
                  })
                })
              }
              itemList.push({
                sourceType:item.sourceType,
                sourceId:item.sourceId,
                periodRule:item.periodRule,
                name:item.name,
                formId:item.formId,
                mappingList:mappingList,
                periodItemId:item.periodItemId,
                checkValueType:item.checkValueType,
              })
            })
          }
          if(that.model.itemList2){
            that.model.itemList2.forEach(item=>{
              itemList.push({
                sourceType:item.sourceType,
                sourceId:item.sourceId,
                periodRule:item.periodRule,
                name:item.name,
                formId:item.formId,
              })
            })
          }
          if(that.model.itemList3){
            that.model.itemList3.forEach(item=>{
              itemList.push({
                sourceType:item.sourceType,
                sourceId:item.sourceId,
                periodRule:item.periodRule,
                name:item.name,
                formId:item.formId,
                periodItemId:item.periodItemId,
              })
            })
          }
          const model = {
            id:that.model.id,
            type:that.model.type,            
            sortNum:that.model.sortNum,
            children:that.model.children,
            description:that.model.description,
            filterList:that.model.filterList,
            formId:that.model.formId,
            formItemId:that.model.formItemId,
            formula:that.model.formula,
            onlyParse:that.model.onlyParse,
            periodRule:that.model.periodRule,
            itemList:itemList,
            resultList:that.model.resultList,
          }
          that.confirmLoading = true
          postAction('/tempconfig/formula/create', model).then((res) => {
            if (res.success) {
              that.$message.success(res.message)
              that.$emit('ok')
              that.close()
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
          })
        },
        onCancel() {
          // console.log('Cancel');
        },
      })
    },

    handleCancel() {
      this.close()
    },
    /**
     * 下一步 每一步都需要验证表单
     */
    next() {
      let model = this.model
      //当前步骤表单验证
      const step = this.$refs[`step${this.current+1}`]
      if (step ) {
        if(!step.validate()){
          return false
        }
        model = step.model
      }
      this.model = model
      const current = this.current+1
      //验证通过,进入下一步
      switch (current) {
        case 0:
          break
        case 1:
          this.cancelText = '上一步'
          break;
        case 2:
          break
        case 3:
          break
        case 4:
          break
        case 5:
          this.okText = '确定'
          break
        case 6:
          //确定保存
          this.handleOk()
          break
      }
      if(current <6){
        this.current  = current
        this.$nextTick(()=>{
          this.$refs[`step${this.current+1}`].view(model)
        })
      }
    },
    prev(e) {
      /*右上角关闭操作直接关闭*/
      if (!e.target.innerText) {
        this.handleCancel()
        return
      }
      switch (this.current) {
        case 0:
          this.handleCancel()
          break
        case 1:
          this.cancelText = '关闭'
          break
        case 2:
          break
        case 3:
          break
        case 4:
          break
        case 5:
          this.okText = '下一步'
          break
      }
      if(this.current>=0){
        this.current--
      }
    },

  }

}
</script>

<style scoped>
/deep/ .ant-tabs-bar {
  display: none;
}

.footer-btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  /*background: #fff;*/
  border-radius: 0 0 4px 4px;
  z-index: 9;
  background: #F8F8F8;
}

/deep/.ant-drawer-header {
  background: #F8F8F8;
}


</style>
